






































































import { Component, Prop, Model, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { IconConfig } from '../sw-icon';
import { SwIconButton } from '../sw-icon-button';
import { CSSStyleOptions } from '../common-types';
import SwTextfield from './sw-textfield.vue';

const cssPrefix = 'sw-expandable-textfield';

/**
 * @event change-expand `(expanding: boolean)`
 * Supports all events emitted by `sw-testfield`
 */
@Component({
  components: {
    SwIconButton,
    SwTextfield,
  },
})
export default class SwExpandableTextfield extends SwExtendedVue {
  @Prop({ type: Object })
  icon: IconConfig;

  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  @Prop({ type: [Number, String], default: 180 })
  expandWidth: number | string;

  @Prop({ type: Boolean, required: true })
  expanded: boolean;

  @Prop({ type: Boolean, default: false })
  withClearButton: boolean;

  /** for proxy to internal textfield */
  @Model('input', { type: String, required: true })
  value: string;

  cssPrefix = cssPrefix;

  transitionEndShowTextfield: boolean = this.expanded;

  get showClearButton(): boolean {
    return this.showTextfield && this.withClearButton && !!this.value;
  }

  get showTextfield(): boolean {
    if (this.expanded) { return true; }
    return this.transitionEndShowTextfield;
  }

  get effectiveTextfieldProps() {
    return Object.assign(
      {},
      this.$attrs,
      {
        icon: Object.assign({ size: 16 } as IconConfig, this.icon),
        iconAsPrefix: true,
      },
    );
  }

  get effectiveWidth(): string | undefined {
    if (this.expanded) {
      return typeof this.expandWidth === 'string' ? this.expandWidth : `${this.expandWidth}px`;
    }
    return undefined;
  }

  get rootStyle(): CSSStyleOptions {
    return {
      width: this.effectiveWidth,
    };
  }

  @Watch('expanded')
  onExpandedChange() {
    this.$nextTick(() => {
      if (this.expanded && this.$refs.textfield) {
        (this.$refs.textfield as SwTextfield).focus();
      }
    });
  }

  private onClickTrigger() {
    this.$emit('change-expand', true);
  }

  private onTextIconClick() {
    this.$emit('change-expand', false);
  }

  private onClearButtonClick() {
    this.$emit('clear');
  }

  private onExpandTransitionEnd() {
    this.transitionEndShowTextfield = this.expanded;
  }
}
